import { Grid, Box, Typography } from "@mui/material";
import { formatDateShort } from "../utils";


const CommunityStatItem = ({community}) => {
    return (
    <>
    <Grid container spacing={0.5}>
    <Grid item xs={12} md={5}>
    <Typography variant="body2" sx={{ fontWeight: "bold", mb: 0 }}>
        {community.name}
    </Typography>
    </Grid>
    <Grid item xs={12} md={3}>
    <Box sx={{ display: "flex", justifyContent: "space-between", flexWrap: "wrap" }}>
        <Typography variant="body2" sx={{ color: "textSecondary" }}>
            {community.count_comments > 0 ? <>💬&nbsp;<strong>{community.count.toLocaleString()}</strong> / <strong>{community.count_comments.toLocaleString()}</strong></> :
            <>💬&nbsp;<strong>{community.count.toLocaleString()}</strong></>}
        </Typography>
    </Box>
    </Grid>
    <Grid item xs={12} md={4}>
        <Typography variant="body2" sx={{ color: "textSecondary" }}>
        📅&nbsp;{formatDateShort(community.earliest_post_date)} &mdash; {formatDateShort(community.latest_post_date)}
    </Typography>
    </Grid>
  </Grid>
  </>
  )
}

export default CommunityStatItem;